export default __webpack_public_path__ + "static/media/html_5.e7638e36.svg";